import { render, staticRenderFns } from "./SendMessage.vue?vue&type=template&id=b079c5d6&scoped=true&"
import script from "./SendMessage.vue?vue&type=script&lang=js&"
export * from "./SendMessage.vue?vue&type=script&lang=js&"
import style0 from "./SendMessage.vue?vue&type=style&index=0&id=b079c5d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b079c5d6",
  null
  
)

export default component.exports